import React from 'react';
import { View } from 'react-native';
import { Text } from '@ui-kitten/components';
import { EvaStatus } from '@ui-kitten/components/devsupport';

import { RectangleLoader } from '../../Components/Loader';
import ResponsiveText from '../../Components/ResponsiveText';
import themeStyle from '../../Theme/styles';

const StoreTagsLoader = ({
  category,
  containerStyle,
}: {
  category?: EvaStatus;
  containerStyle?: any;
}) => {
  return (
    <View style={[themeStyle.flexDirectionRowCenter, containerStyle]}>
      <RectangleLoader width={150} height={27.5} />
      <View style={themeStyle.rowSeparator} />
      <RectangleLoader width={100} height={27.5} />
      <ResponsiveText category={category}> · </ResponsiveText>
      <RectangleLoader width={50} height={27.5} />
    </View>
  );
};

export default StoreTagsLoader;
